import React from "react";
import { Route, Switch } from "react-router-dom";

import * as QueriesQL from "queries/bucket-file";
import * as Section from "@repoflow/components/section";
import { Crumb } from "@repoflow/components/breadcrumb";

import * as ViewRoute from "./view";
import * as EditRoute from "./edit";
import * as RemoveRoute from "./remove";

const LocalProvider = ({
  match: {
    params,
    params: { bucketId, fileId },
  },
  children: Children,
}) => {
  const {
    base: parentBase,
    basepath: parentBasepath,
    schema,
    values: bucket,
  } = Section.useSectionContext();

  const base = `${parentBase}/${fileId}`;
  const basepath = `${parentBasepath}/:fileId`;

  // Keyed on the entity, which is what the accidental remount used to do.
  //
  // Every screen below seeds its form state ONCE, from the entity this
  // route resolved. Until the render prop above was called rather than
  // rendered, React saw a new component type on every render and remounted
  // the lot — which reset those forms, and happened to be what made moving
  // from one fileId to another show the new one's values. It no longer
  // remounts for free, so the reset it was providing is asked for here.
  return (
    <Section.Provider
      key={fileId}
      schema={schema}
      base={base}
      basepath={basepath}
      attributes={{ ...params, bucket }}
    >
      {/* Called, never rendered as an element — see Section.Provider. */}
      {Children({ base, basepath, params })}
    </Section.Provider>
  );
};

export const Content = (props) => {
  return (
    <LocalProvider {...props}>
      {({ params: { bucketId, fileId } }) => (
        <Section.Query
          query={QueriesQL.get}
          variables={{ bucketId, fileId }}
          datapath={"buckets.get.files.get"}
        >
          {ContentHandler}
        </Section.Query>
      )}
    </LocalProvider>
  );
};

function ContentHandler({ basepath }) {
  return (
    <Switch>
      <Route path={`${basepath}/remove`} component={RemoveRoute.Content} />
      <Route path={`${basepath}/edit`} component={EditRoute.Content} />
      <Route path={`${basepath}/`} component={ViewRoute.Content} />
    </Switch>
  );
}

export const Sidebar = () => (
  <>
    <EditRoute.Sidebar />
    <RemoveRoute.Sidebar />
  </>
);

export function Indice(props) {
  return (
    <LocalProvider {...props}>
      {({ base, basepath, params: { fileId } }) => (
        <>
          <Crumb to={`${base}`} label={fileId} />
          <Switch>
            <Route path={`${basepath}/edit`} component={EditRoute.Indice} />
            <Route path={`${basepath}/remove`} component={RemoveRoute.Indice} />
            <Route path={`${basepath}/`} component={ViewRoute.Indice} />
          </Switch>
        </>
      )}
    </LocalProvider>
  );
}
